import { FC, useEffect, useState } from 'react'

// Common
import MainModal from './common/MainModal'

// Components
import { SelectOption } from '../selects/SelectOption'

// Const
import { MODAL_CONSTS } from '../../const/modal-const'

// Store
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import {
  riderProfileRegistrationActions,
  selectRiderProfileType,
} from '../../store/riderProfileRegistration/riderProfileRegistrationSlice'

// Types
import { ECompetitorTypes } from '../../types/competitor_types'

interface CreateRiderProfileModalProps {
  handleModal: (showHide: boolean, typeOfModal: string, data?: any) => void
}

const OPTIONS = [
  {
    option: ECompetitorTypes.loneRider,
    title: 'Lone rider',
    description: 'I register for events alone, just me and my horse.',
  },
  {
    option: ECompetitorTypes.teamRider,
    title: 'Team rider',
    description:
      'I register for events with team members such as my trainer, owner, guardian, etc.',
  },
  {
    option: ECompetitorTypes.guardian,
    title: 'Guardian',
    description: 'I am a guardian setting up an account for a minor',
  },
  {
    option: ECompetitorTypes.spectator,
    title: 'Auditor, Spectator, Team member',
    description: 'I’m not riding, just attending or supporting an event',
  },
]

export const CreateRiderProfileStepOneModal: FC<CreateRiderProfileModalProps> = ({
  handleModal,
}) => {
  const dispatch = useAppDispatch()

  const [selectedOption, setSelectedOption] = useState<ECompetitorTypes>(ECompetitorTypes.none)
  const riderProfileType = useAppSelector(selectRiderProfileType)

  useEffect(() => {
    if (riderProfileType) setSelectedOption(riderProfileType)
  }, [riderProfileType])

  const nextHandler = () => {
    dispatch(riderProfileRegistrationActions.setProfileType(selectedOption))
    handleModal(false, MODAL_CONSTS.CREATE_RIDER_PROFILE_STEP_1)
    handleModal(true, MODAL_CONSTS.CREATE_RIDER_PROFILE_STEP_2)
  }

  return (
    <MainModal
      title="Create rider profile"
      description={'Which best describes you?'}
      show={true}
      type="CREATE_RIDER_PROFILE_STEP_1"
      size={'lg'}
      buttons={[
        {
          label: 'NEXT >',
          fullWidth: true,
          disabled: selectedOption === ECompetitorTypes.none,
          onClick: nextHandler,
        },
        {
          label: 'CANCEL',
          fullWidth: true,
          className: 'outline-none',
          borderClass: 'border border-transparent',
          bgClass: 'bg-SeabiscuitLightThemeColor',
          textClass: 'text-SeabiscuitLightTextColor',
          onClick: () => {
            dispatch(riderProfileRegistrationActions.clear())
            handleModal(false, MODAL_CONSTS.CREATE_RIDER_PROFILE_STEP_1)
          },
        },
      ]}
    >
      <div className={'-ml-2 -mr-2 text-SeabiscuitDark200ThemeColor'}>
        <div className={'flex flex-col gap-2.5 mt-5'}>
          {OPTIONS.map(({ option, title, description }) => (
            <SelectOption
              key={option}
              isActive={selectedOption === option}
              title={title}
              description={description}
              onClick={() => setSelectedOption(option)}
            />
          ))}
        </div>
      </div>
    </MainModal>
  )
}
